import Api from '@/services/api';
import qs from 'querystring';

export default {
  search(
    value,
    fields,
    filters = [],
    hiddenFilter = "",
    page = 1,
    sortBy = "nom_soc",
    sortDesc = false
  ) {
    return Api().post(
      "/debtors/search",
      qs.stringify({
        search: value,
        fields: fields,
        filters: JSON.stringify(filters),
        hiddenFilter: hiddenFilter,
        page: page,
        sortBy: sortBy,
        sortDesc: sortDesc,
      })
    );
  },
  search_to_check(
    value,
    fields,
    filters = [],
    hiddenFilter = "",
    page = 1,
    sortBy = "nom_soc",
    sortDesc = false
  ) {
    return Api().post(
      "/debtors/search-to-check",
      qs.stringify({
        search: value,
        fields: fields,
        filters: JSON.stringify(filters),
        hiddenFilter: hiddenFilter,
        page: page,
        sortBy: sortBy,
        sortDesc: sortDesc,
      })
    );
  },
  get(id) {
    return Api().get("/debtor/" + id);
  },
  get_titres(langue) {
    return Api().get("/debtor/titres/" + langue);
  },
  post(debtorObject) {
    return Api().post(
      "/debtor",
      qs.stringify({
        object: JSON.stringify(debtorObject),
      })
    );
  },
  delete_debtor(id) {
    return Api().delete("/debtor/" + id);
  },
  warrants_info(id) {
    return Api().get("/debtor/warrants-info/" + id);
  },
  warrants_migrate(id_source, id_target) {
    return Api().get(
      "/debtor/warrants-migrate/" + id_source + "/" + id_target
    );
  },
  last_updated() {
    return Api().get("/debtors/last-updated");
  },
};